import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'Helvetica',
    backgroundColor: '#FFFFFF',
    color: '#000000',
  },
  header: {
    marginBottom: 20,
    paddingBottom: 10,
    borderBottom: '1px solid #E5E7EB',
  },
  title: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 5,
  },
  subtitle: {
    fontSize: 14,
    color: '#6B7280',
  },
  section: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#111827',
    borderBottom: '1px solid #E5E7EB',
    paddingBottom: 5,
  },
  table: {
    width: '100%',
    marginBottom: 20,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableHeader: {
    backgroundColor: '#F3F4F6',
    color: '#111827',
    fontWeight: 'bold',
    padding: 8,
    textAlign: 'center',
    fontSize: 10,
    border: '1px solid #E5E7EB',
    flex: 1,
  },
  tableCell: {
    padding: 8,
    fontSize: 10,
    border: '1px solid #E5E7EB',
    flex: 1,
  },
  featureItem: {
    marginBottom: 10,
    padding: 10,
    backgroundColor: '#F9FAFB',
    borderRadius: 4,
    borderLeft: '3px solid #3B82F6',
  },
  step: {
    marginBottom: 15,
    paddingLeft: 15,
    borderLeft: '2px solid #E5E7EB',
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 40,
    right: 40,
    textAlign: 'center',
    fontSize: 10,
    color: '#9CA3AF',
    borderTop: '1px solid #E5E7EB',
    paddingTop: 10,
  },
});

const AdvancedEMICalculatorExcel = () => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text style={styles.title}>Advanced EMI Calculator Excel</Text>
        <Text style={styles.subtitle}>Professional Loan Analysis Tool</Text>
      </View>
      
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Features:</Text>
        <View style={styles.featureItem}>
          <Text>• EMI Calculation with Prepayment Options</Text>
          <Text>• Tax Benefits Calculator</Text>
          <Text>• Amortization Schedule</Text>
          <Text>• Multiple Loan Comparison</Text>
          <Text>• Break-up of Principal & Interest</Text>
          <Text>• Pre-closure & Part-payment Analysis</Text>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>How to Use:</Text>
        <View style={styles.step}>
          <Text>1. Enter Loan Amount, Interest Rate, and Tenure</Text>
          <Text>2. Adjust Prepayment Amounts if any</Text>
          <Text>3. View Detailed Amortization Schedule</Text>
          <Text>4. Compare Different Loan Scenarios</Text>
        </View>
      </View>

      <View style={styles.footer}>
        <Text>© {new Date().getFullYear()} White Pearl Finance - Advanced EMI Calculator</Text>
      </View>
    </Page>
  </Document>
);

export default AdvancedEMICalculatorExcel;
